import React from "react";
import { Typography } from "@material-ui/core";
import { COLORS } from "../styles";

interface SidebarSectionHeaderProps {
  title: string;
}

const SidebarSectionHeader: React.FC<SidebarSectionHeaderProps> = ({
  title,
}) => {
  return (
    <div style={{ padding: "12px 16px 12px 16px" }}>
      <Typography
        variant="subtitle2"
        style={{
          color: COLORS.textDark,
          fontWeight: 700,
          marginBottom: 0,
          textTransform: "uppercase",
          fontSize: "12px",
          letterSpacing: "0.8px",
        }}
      >
        {title}
      </Typography>
    </div>
  );
};

export default SidebarSectionHeader;
